import { z } from "zod/v4-mini";

export const carePlanInterruptionReasons = ["consent_withdrawal", "deceased", "other"] as const;
export const carePlanInterruptionReasonSchema = z.enum(carePlanInterruptionReasons, "form.required");
export type CarePlanInterruptionReason = z.infer<typeof carePlanInterruptionReasonSchema>;

export const carePlanInterruptionReasonTranslationMapping = (reason: CarePlanInterruptionReason): string => {
  switch (reason) {
    case "consent_withdrawal":
      return "carePlanInterruption.reasons.consentWithdrawal";
    case "deceased":
      return "carePlanInterruption.reasons.deceased";
    case "other":
      return "carePlanInterruption.reasons.other";
  }
};

export type InterruptCarePlanData = {
  reason: CarePlanInterruptionReason;
};
